import axios from "axios";

export const state = {
    loanapplications: [],
};

export const getters = {
    loanapplications: state => state.loanapplications,
};

export const mutations = {
    setLoanApplications(state, newValue) {
        state.loanapplications = newValue
    },
};

export const actions = {
    async fetchLoanApplications({ commit }) {
        await axios.get('/loanapplications').then(res => {
            commit('setLoanApplications', res.data.loanapplications)
        })
    },
    async filterLoanApplications({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterloanapplications";
        await axios.post(url, formData).then((response) => {
            commit('setLoanApplications', response.data.loanapplications)
        })
    },
};
